import Component from '@glimmer/component';
import {
  isAwsProviderNetwork,
  isAzureProviderNetwork,
} from 'networks-common/utils/networks';
import Aws from 'hcp/components/page/hvn-peerings/detail/content-tabs/aws';
import Azure from 'hcp/components/page/hvn-peerings/detail/content-tabs/azure';

/**
 *
 * `PageHvnPeeringsDetailContentTabs` renders the HVN Peerings Detail tabs content based on provider
 *
 *
 * ```
 * <PageHvnPeeringsDetailTabsContent @model=={{@model}}/>
 * ```
 *
 * @class PageHvnPeeringsDetailTabsContent
 *
 */
export default class PageHvnPeeringsDetailTabsContent extends Component {
  get isAws() {
    return isAwsProviderNetwork(this.args.model.network);
  }
  get isAzure() {
    return isAzureProviderNetwork(this.args.model.network);
  }
  <template>
    {{#if this.isAws}}
      <Aws
        @model={{@model}}
        @tab={{@tab}}
        @product={{@product}}
        @peering={{@model.peering}}
      />
    {{else if this.isAzure}}
      <Azure
        @model={{@model}}
        @tab={{@tab}}
        @product={{@product}}
        @peering={{@model.peering}}
      />
    {{/if}}
  </template>
}
